import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController, Platform } from 'ionic-angular';
import { Subscription as RxjsSubscription } from 'rxjs';
import { Subscription } from '../../models/subscription';
import { Api } from '../../providers/api';
import { SubscriptionService } from '../../providers/subscription-service';
import { UserService } from '../../providers/user-service';
import { LoginPage } from '../login/login';
import { InAppPurchase } from '@ionic-native/in-app-purchase';
import { SubscriptionsPage } from '../subscriptions/subscriptions';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { ChangePasswordPage } from '../change-password/change-password';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics';

@Component({
    selector: 'page-my-account',
    templateUrl: 'my-account.html'
})

export class MyAccountPage {

    public subscription: Subscription = null;
    public subscriptionWatcher: RxjsSubscription;

    constructor(
        public alertCtrl: AlertController,
        public analytics: FirebaseAnalytics,
        public api: Api,
        public inAppBrowser: InAppBrowser,
        public inAppPurchase: InAppPurchase,
        public loadingCtrl: LoadingController,
        public navCtrl: NavController,
        public platform: Platform,
        public subscriptionService: SubscriptionService,
        public userService: UserService,
    ) {

    }

    public ionViewDidEnter() {
        this.analytics.setCurrentScreen('MyAccount');
    }

    public ngAfterViewInit() {
        this.subscription = this.subscriptionService.get();
        this.subscriptionWatcher = this.subscriptionService.watch().subscribe(subscription => this.subscription = subscription);
    }

    public ngOnDestroy() {
        if (this.subscriptionWatcher && !this.subscriptionWatcher.closed) this.subscriptionWatcher.unsubscribe();
    }

    public manageSubscription() {
        if (this.subscription) this.goToManageSubscription();
        else this.goToPurchaseSubscription();
    }

    public goToManageSubscription() {
        if (this.platform.is('android')) {
            let iab = this.inAppBrowser.create('https://play.google.com/store/account/subscriptions', '_system');
            iab.show();
        }
        if (this.platform.is('ios')) {
            let iab = this.inAppBrowser.create('itms-apps://itunes.apple.com/app/id/1447228413', '_system');
            iab.show();
        }
    }

    public async goToPurchaseSubscription() {
        let loading = this.loadingCtrl.create();
        loading.present();

        try {
            let productIds = await this.api.getProductIds().toPromise();
            let productId;

            if (this.platform.is('android')) productId = productIds.product_ids.android;
            if (this.platform.is('ios')) productId = productIds.product_ids.ios;

            let products = await this.inAppPurchase.getProducts([productId]);

            this.navCtrl.push(SubscriptionsPage, {
                product: products[0],
                type: productIds.type
            });
        } catch (error) {
            let alert = this.alertCtrl.create({
                title: 'Error',
                message: JSON.stringify(error),
                buttons: [{
                    text: 'OK'
                }]
            });

            alert.present();
        } finally {
            loading.dismiss();
        }
    }

    public logout() {
        let alert = this.alertCtrl.create({
            title: 'Logout',
            message: 'Are you sure you want to log out?',
            buttons: [{
                text: 'Yes',
                handler: () => {
                    this.confirmLogout()
                }
            }, {
                text: 'No',
            }]
        });

        alert.present();
    }

    public async confirmLogout() {
        let loading = this.loadingCtrl.create();
        loading.present();

        try {
            // The request to the server is preferrable but not absolutely necessary
            try { await this.api.getLogout().toPromise(); } catch {}

            // These bits are necessary however
            await Promise.all([
                this.api.clearTokenAndStore(),
                this.subscriptionService.clearAndStore(),
                this.userService.clearAndStore(),
            ]);

            this.navCtrl.setRoot(LoginPage, null, {
                animate: true,
                direction: 'back',
            });
        } catch (error) {
            let alert = this.alertCtrl.create({
                title: 'Error',
                message: 'An unknown error occured while performing the log out request',
                buttons: [{
                    text: 'OK'
                }]
            });

            alert.present();
        } finally {
            loading.dismiss();
        }
    }

    public showChangePassword() {
        this.navCtrl.push(ChangePasswordPage);
    }

}



// WEBPACK FOOTER //
// ./src/pages/my-account/my-account.ts